import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Transition as _Transition, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/financialFitness.png';
import _imports_1 from '../assets/moneyHelper.png';
const _hoisted_1 = {
    key: 0,
    class: "simplePage",
    style: { "margin-top": "-40px" }
};
const _hoisted_2 = { class: "anchor-bottom" };
const _hoisted_3 = {
    key: 0,
    class: "simplePage",
    style: { "margin-top": "-40px" }
};
const _hoisted_4 = { class: "anchor-bottom" };
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useQuizApi } from '@/composables/useQuizApi';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FinancialFitnessLandingPage',
    setup(__props) {
        const router = useRouter();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getQuestionnaireByKey } = useQuizApi();
        const about = ref(false);
        function onLoad() {
            getCustomer();
        }
        function startSurvey() {
            getQuestionnaireByKey('FFS', (q) => {
                console.log(q, 'Found this questionnaire');
                router.replace({ path: '/Questionnaire/' + q.id, query: { theme: 'light', allowBack: 'true', allowSkip: 'false', escapeRoute: 'you' } });
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    bgcolor: "#00000000",
                    border: "0"
                }),
                (!about.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Financial Fitness Score", -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("p", null, "Our financial fitness survey has been developed after extensive research by MoneyHelper.", -1)),
                        _cache[6] || (_cache[6] = _createElementVNode("p", null, "The survey will help to identify areas of your finance that you may want to prioritise.", -1)),
                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "bold" }, "The survey should take you no more than 10 minutes to complete.", -1)),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "info onlyTallScreen" }, [
                            _createElementVNode("h1", null, "Your details are private & confidential."),
                            _createElementVNode("p", null, "We will not share any of your information with MoneyHelper, your employer or any other 3rd party organisation")
                        ], -1)),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(MGButton, {
                                text: "Get Started",
                                arrow: "",
                                onClick: _cache[0] || (_cache[0] = ($event) => (about.value = true))
                            }),
                            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "partnership" }, [
                                _createTextVNode("In partnership with "),
                                _createElementVNode("img", { src: _imports_1 })
                            ], -1))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (about.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "well" }, [
                                    _createElementVNode("img", { src: _imports_1 }),
                                    _createElementVNode("h1", null, "Making your money and pension choices clearer"),
                                    _createElementVNode("p", null, "MoneyHelper is here to help, so you can move on with life. Here to cut through the jargon and complexity, explain what you need to do and how you can do it. Here to put you in control, with free, impartial help for money and pensions that's quick to find, easy to use and backed by government."),
                                    _createElementVNode("p", { class: "onlyTallScreen" }, "Whatever your circumstances or plans, we offer clear guidance online, over the phone and face-to-face. We can also point you to trusted services, if you need more support."),
                                    _createElementVNode("p", { class: "onlyTallScreen" }, "Find out more at:"),
                                    _createElementVNode("p", { class: "bold onlyTallScreen" }, "www.moneyhelper.org.uk")
                                ], -1)),
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "5" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(MGButton, {
                                                        text: "Back",
                                                        outline: "",
                                                        onClick: _cache[1] || (_cache[1] = ($event) => (about.value = false))
                                                    })
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(MGButton, {
                                                        text: "Next",
                                                        arrow: "",
                                                        onClick: startSurvey
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
